import React, { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useCart } from "../lib/CartContext";

let sdkPromise = null;
function loadPayPalSdk(clientId) {
  if (window.paypal) return Promise.resolve(window.paypal);
  if (sdkPromise) return sdkPromise;
  sdkPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = `https://www.paypal.com/sdk/js?client-id=${encodeURIComponent(clientId)}&currency=USD&intent=capture&disable-funding=credit,card`;
    s.onload = () => resolve(window.paypal);
    s.onerror = () => { sdkPromise = null; reject(new Error("Failed to load PayPal")); };
    document.body.appendChild(s);
  });
  return sdkPromise;
}

// PayPal buttons for the whole cart (guest OR member). Renders nothing until PayPal is configured.
export default function PayPalCartCheckout({ onSuccess }) {
  const { items } = useCart();
  const [cfg, setCfg] = useState(null);
  const [ready, setReady] = useState(false);
  const holder = useRef(null);
  const itemsRef = useRef(items);
  useEffect(() => { itemsRef.current = items; }, [items]);

  useEffect(() => { api.get("/payments/paypal/config").then(({ data }) => setCfg(data)).catch(() => setCfg({ enabled: false })); }, []);

  useEffect(() => {
    if (!cfg?.enabled || !holder.current) return;
    let cancelled = false;
    loadPayPalSdk(cfg.clientId).then((paypal) => {
      if (cancelled || !holder.current) return;
      holder.current.innerHTML = "";
      paypal.Buttons({
        style: { layout: "horizontal", color: "gold", shape: "pill", height: 44, tagline: false },
        createOrder: () => api.post("/payments/paypal/cart/create-order", {
          items: itemsRef.current.map((i) => ({ sku: i.sku, quantity: i.qty })),
          origin_url: window.location.origin,
        }).then((r) => r.data.orderId),
        onApprove: (data) => api.post("/payments/paypal/cart/capture", { orderId: data.orderID }).then((r) => {
          if (r.data.status === "paid") { toast.success("Payment complete — thank you! 💛"); onSuccess?.(r.data.order_number, r.data.session_id); }
          else toast.error("Payment could not be completed.");
        }).catch(() => toast.error("Payment could not be completed.")),
        onError: () => toast.error("PayPal error — please try again."),
      }).render(holder.current).then(() => !cancelled && setReady(true)).catch(() => {});
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [cfg, onSuccess]);

  if (!cfg?.enabled) return null;
  return (
    <div className="mt-2" data-testid="paypal-cart">
      {!ready && <div className="h-11 rounded-full bg-cream animate-pulse" />}
      <div ref={holder} />
    </div>
  );
}
